import React, { useState } from 'react'
import { Form, Icon, Input, Modal, Row, Select, Upload, Col, Button } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import _, { isNull } from 'lodash'

const StepForm = (props) => {
  const { visible, onOk, onCancel, formData, form, stepType } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        stepType: formData.stepType.id,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          stepTypeId: values.stepType,
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      visible={visible}
      title={`${!_.isEmpty(formData) ? 'Edit ' : 'Create a new '} Step`}
      footer={null}
      onCancel={onCancel}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item label="ขั้นตอน">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ขั้นตอน" />)}
        </Form.Item>
        <Form.Item label="ประเภท">
          {getFieldDecorator(`stepType`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกประเภท"
              name="stepType"
              allowClear
            >
              {stepType && stepType.map(stepType => (
                <Select.Option key={stepType.name} value={stepType.id}>
                  {stepType.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              {`${!_.isEmpty(formData) ? 'Save ' : 'Create'}`}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedStepForm = Form.create({
  name: 'StepForm'
})(StepForm)
export default (WrappedStepForm)



// WEBPACK FOOTER //
// ./src/pages/Step/components/StepForm/index.js